import { TranslationKey } from '../../i18n/translationKeys';
import type { ConnectionHealthReason } from '../../types/acombaBridge';

/**
 * Maps a bridge {@link ConnectionHealthReason} to the translation key shown as the session error on the
 * Acomba page. The bridge's English `message` is for debugging only — the client renders localized copy
 * keyed off this machine-readable reason (per the ConnectionHealthResult contract).
 *
 * Returns null when no inline error line should show: an ok/connected session, the first-load
 * no-credentials case (the form itself is the prompt), and SdkUnavailable (explained by its own banner).
 */
export function bridgeSessionReasonKey(reason: ConnectionHealthReason | null | undefined): string | null {
    switch (reason) {
        case 'AuthenticationFailed':
            return TranslationKey.AcombaBridge.SessionReason.AuthenticationFailed;
        case 'CompanyLocked':
            return TranslationKey.AcombaBridge.SessionReason.CompanyLocked;
        case 'InsufficientRights':
            return TranslationKey.AcombaBridge.Errors.InsufficientRights;
        case 'Unknown':
            return TranslationKey.AcombaBridge.SessionReason.Unknown;
        default:
            return null;
    }
}
